<div class="single-page">
    <div class="carousel">
        <app-carousel></app-carousel>
    </div>

    <app-register-account class="content"></app-register-account>

  </div>
<app-auth-footer></app-auth-footer>
